export enum QueryParamType {
  Action = 'action',
  ActiveTab = 'activeTab',
  ClientId = 'client_id',
  Clause = 'clause',
  clauseId = 'clauseId',
  Code = 'code',
  CommentId = 'commentId',
  CompareTo = 'compareTo',
  DocumentId = 'documentId',
  Expanded = 'expanded',
  Error = 'error',
  EviPersistKey = 'eviPersistKey',
  ExportId = 'exportId',
  FirstLoginSuccessToken = 'first_login_success_token',
  RolodexFirstLoginSuccess = 'rolodex_first_login_success',
  FormData = 'formData',
  IsAllSelected = 'isAllSelected',
  KeywordMatchesQuery = 'keywordMatchesQuery',
  Layout = 'layout',
  Page = 'page',
  PageSize = 'pageSize',
  Provider = 'provider',
  Query = 'query',
  RedirectUri = 'redirect_uri',
  ResetSuccessToken = 'reset_success_token',
  RolodexResetSuccess = 'rolodex_reset_success',
  ResponseType = 'response_type',
  OpenPlaybookPanel = 'openPlaybookPanel',
  PlaybookId = 'playbookId',
  ReturnTo = 'return_to',
  ReturnUrl = 'return_url',
  SamlError = 'saml_error',
  SamlSuccess = 'saml_success',
  SearchText = 'searchText',
  SelectedItems = 'selectedItems',
  Slug = 'slug',
  State = 'state',
  States = 'states',
  RedirectTokenId = 'id',
  SortedColumn = 'sortedColumn',
  SortedOrder = 'sortedOrder',
  Sso = 'sso',
  SsoSuccess = 'sso_success',
  StytchTokenType = 'stytch_token_type',
  Success = 'success',
  TaskId = 'taskId',
  TicketCommentId = 'ticketCommentId',
  TicketId = 'ticketId',
  Token = 'token',
  VersionId = 'versionId',
  Workspace = 'workspace',
}
